import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const StyledWrapper = styled.div`
  align-items: center;
  background-color: #fff;
  display: flex;
  height: 55px;
  justify-content: space-between;
  padding: 0 46px 0 53px;
`

export const StyledLink = styled(Link)`
  background-color: ${props => props.theme.colors.primary};
  border-radius: 4px;
  color: #fff;
  font-family: ${props => props.theme.fonts.robotoRegular};
  font-size: 14px;
  font-weight: 500;
  height: 21px;
  text-align: center;
  width: 196px;

  &:hover {
    color: #fff;
    text-decoration: none;
  }
`
